import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
export const Input = React.forwardRef(({ className = '', type = 'text', ...props }, ref) => {
    return (_jsx("input", { ref: ref, type: type, className: `flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 ${className}`, ...props }));
});
Input.displayName = 'Input';
